import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CallStateEnum } from '@models/call-state.model.ts';
import useProfileStore from '@store/profile-store/profile.store.ts';
import { isHotelWifiEnabled } from '@shared/utils/organization-config.utils.ts';

type HotelWifiFeatureGuardProps = {
  redirectTo: string;
  children?: React.ReactNode;
};

const HotelWifiFeatureGuard: React.FC<HotelWifiFeatureGuardProps> = ({
  redirectTo,
  children
}) => {
  const callState = useProfileStore((s) => s.callState);
  const profileData = useProfileStore((s) => s.profileData);

  if (
    callState === CallStateEnum.Init ||
    callState === CallStateEnum.Loading
  ) {
    return null;
  }

  if (!isHotelWifiEnabled(profileData?.organization?.config)) {
    return <Navigate to={redirectTo} replace />;
  }

  if (children !== undefined) {
    return <>{children}</>;
  }

  return <Outlet />;
};

export default HotelWifiFeatureGuard;
